<!--  -->
<template>
  <div class="GoodsDetails">
    <div class="goodsdetails-loop">
      <swiper
        :auto-update="true"
        class="maf-swiper"
        ref="mySwiper"
        :options="swiperOption"
      >
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in goodsloop"
          :key="index"
        >
          <div class="shiyong">
            <router-link :to="url1"
              >{{ chakan }}
              <img src="../../assets/LungProLookmore.png" />
            </router-link>
          </div>
          <div class="loopimg">
            <img :src="item.src" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="goodsdetails-text">
      <h1></h1>
      <p v-html="msg" :class="{ Allshow: this.LookMore == true }"></p>
      <div class="lookMore" v-if="!LookMore" @click="onLookMore">
        <img src="../../assets/allshow.png" />
      </div>
    </div>
    <div class="xiangguan">
      <router-link :to="url2">
        <div class="lookvideo">{{ lookvideo }}</div>
      </router-link>
      <h1>{{ xiangguantitle }}</h1>
      <ul class="related-products">
        <li v-for="(item, index) in xiangguanList" :key="index">
          <router-link :to="item.url" @click.native="flushCom">
            <div class="xiangguan-img">
              <img :src="item.src" />
            </div>
            <p>{{ item.title }}</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    //这里存放数据
    return {
      id: 0,
      cid: 0,
      url1: "",
      url2: "",
      LookMore: false,
      swiperOption1: {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        speed: 500,
        autoplay: {
          delay: 3000,

          stopOnLastSlide: false,

          disableOnInteraction: false, //操作swiper后不会停止播放
        },
      },
      swiperOption2: {
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        speed: 500,
        autoplay: false,
      },
      chakan: "", //查看成功案例ckcgal
      lookvideo: "", //查看相关文件ckxgwj
      xiangguantitle: "", //相关产品xgcp
      goodsloop: [
        /* 
        {
          title: "LungPro产品图",
          msg: "广泛用于冶金、煤矿、选矿、建材、化工、磨料等行业的破碎、筛分联合设备中，将块状、颗粒状物料从贮料仓库中均匀、定时、连续地给到受料装置中。在破碎生产线中，可为破碎设备连续均匀地给料，并对物料进行初筛分。",
          src: require("../../assets/LungPro.png"),
        },
        {
          title: "LungPro",
          msg: "广泛用于冶金、煤矿、选矿、建材、化工、磨料等行业的破碎、筛分联合设备中，将块状、颗粒状物料从贮料仓库中均匀、定时、连续地给到受料装置中。在破碎生产线中，可为破碎设备连续均匀地给料，并对物料进行初筛分。",
          src: require("../../assets/LungPro.png"),
        },
        {
          title: "LungPro产品",
          msg: "广泛用于冶金、煤矿、选矿、建材、化工、磨料等行业的破碎、筛分联合设备中，将块状、颗粒状物料从贮料仓库中均匀、定时、连续地给到受料装置中。在破碎生产线中，可为破碎设备连续均匀地给料，并对物料进行初筛分。",
          src: require("../../assets/LungPro.png"),
        },
       */
      ],
      xiangguanList: [
        /* 
        {
          id: "",
          src: require("../../assets/LungPro产品图 (1).png"),
          url: "",
          title: "LungPro产品图",
        },
        {
          id: "",
          src: require("../../assets/LungPro产品图 (1).png"),
          url: "",
          title: "LungPro产品图",
        },
        {
          id: "",
          src: require("../../assets/LungPro产品图 (1).png"),
          url: "",
          title: "LungPro产品图",
        },
        {
          id: "",
          src: require("../../assets/LungPro产品图 (1).png"),
          url: "",
          title: "LungPro产品图",
        },
        {
          id: "",
          src: require("../../assets/LungPro产品图 (1).png"),
          url: "",
          title: "LungPro产品图",
        },
       */
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {
    swiperOption() {
      var len = this.goodsloop.length;
      console.log(this.goodsloop);
      if (len == 1) {
        return this.swiperOption2;
      } else {
        return this.swiperOption1;
      }
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.chakan = obj.data["ckcgal"];
            that.lookvideo = obj.data["ckxgwj"];
            that.xiangguantitle = obj.data["xgcp"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.产品详情
    get_detail() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_article",
          article_id: that.id,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          //var sign = [];
          //var msgs = [];
          if (obj.code == "0000") {
            //if (obj.data.sign) sign = obj.data.sign.split("@");
            //if (obj.data.msgs) msgs = obj.data.msgs.split("<br />");
            that.url1 = "/patienlist?gid=" + that.id;
            that.url2 = "/LingchuangList?gid=" + that.id;
            that.msg = obj.data.msg;
            $.each(obj.data.pic_lists, function (i, k) {
              that.goodsloop.push({
                //title: sign[i],
                //msg: msgs[i],
                src: k,
              });
            });
            that.get_xiangg(obj.data.category_id, obj.data.id);
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //3.相关产品
    get_xiangg(cid, id) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: cid,
          neq_id: id,
          show_num: 8,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              that.xiangguanList.push({
                id: k.id,
                src: k.pic_f,
                url: "/goodsdetails?id=" + k.id,
                title: k.title,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    flushCom: function () {
      this.$router.go(0);
    },
    onLookMore() {
      this.LookMore = !this.LookMore;
      console.log(this.LookMore);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var v = parseUrl();
    this.id = v["id"];

    this.get_fanyi();
    this.get_detail();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};

function parseUrl() {
  var url = location.href;
  var i = url.indexOf("?");
  if (i == -1) return;
  var querystr = url.substr(i + 1);
  var arr1 = querystr.split("&");
  var arr2 = new Object();
  for (i in arr1) {
    var ta = arr1[i].split("=");
    arr2[ta[0]] = ta[1];
  }
  return arr2;
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.GoodsDetails {
  width: 100%;
  .goodsdetails-loop {
    width: $main-width;
    height: auto;
    margin: 0 auto;
    background: #ffffff;
    position: relative;
    .shiyong {
      width: 330px;
      background: #7ed1f9;
      border-radius: 10px;
      position: absolute;
      top: 0;
      right: 0;
      color: #fefefe;
      font-size: 1.2rem;
      line-height: 1.5;
      text-align: center;
      a {
        width: 100%;
        height: 100%;
        padding: 15px 20px;
        display: block;
      }
      img {
        display: inline-block;
      }
    }
    .loopimg {
      height: 450px;
      img {
        height: 100%;
      }
    }
    img {
      display: block;
      margin: 0 auto;
    }
    h1 {
      margin-top: 50px;
      color: #0a7ec1;
      font-size: 1.3rem;
      text-align: center;
    }
  }
  .goodsdetails-text {
    width: $main-width;
    margin: 60px auto;
    position: relative;
    .Allshow {
      height: auto;
    }
    .lookMore {
      width: 100px;
      height: 30px;
      background-color: #f0a954;
      margin-left: auto;
      cursor: pointer;
      img {
        display: block;
        padding: 5px 0;
        margin: 0 auto;
      }
    }
    p {
      padding: 0 20px;
      color: #666;
      line-height: 1.5;
      height: 240px;
      overflow: hidden;
    }
    p::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    p::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 5px;
      background: #f8ad17;
    }
    p::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: #e5e5e5;
    }
  }
  .xiangguan {
    width: $main-width;
    margin: 0 auto;
    .lookvideo {
      margin-top: 50px;
      width: 401px;
      background: #f0a954;
      border-radius: 10px;
      text-align: center;
      color: #fefefe;
      padding: 15px 0;
      font-size: 1.2rem;
    }
    h1 {
      margin-top: 40px;
      color: #8b4b9d;
      font-size: 1.3rem;
    }
    .related-products {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 100px;
      li {
        width: 25%;
        margin-top: 40px;
        margin-left: 10px;
        margin-right: 10px;
        .xiangguan-img {
          width: 100%;
          height: 150px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          text-align: center;
          font-size: 0.9rem;
          color: #666;
          padding: 6px 0;
          line-height: 1.5;
        }
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .GoodsDetails {
    .goodsdetails-loop {
      width: 100%;
      .shiyong {
        width: 50%;
      }
      .loopimg {
        max-height: 450px;
        height: auto;
        img {
          max-width: 450px;
          width: 100%;
          height: 100%;
        }
      }
    }
    .goodsdetails-text {
      width: 100%;
      p {
        padding: 0 10px;
      }
    }

    .xiangguan {
      width: 100%;
      a {
        width: 100%;
        height: 100%;
        .lookvideo {
          width: 90%;
          margin: 0 auto;
        }
      }
      h1 {
        padding: 0 10px;
      }
      .related-products {
        justify-content: space-around;
        li {
          width: 30%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/GoodsDetails.vue